import OvulationCalculatorBox from './OvulationCalculatorBox';
import OvulationToolContent from './OvulationToolContent';

export default function OvulationCalculator(props) {
  const { productData } = props;
  return (
    <>
      <OvulationCalculatorBox heading="OVULATION CALCULATOR" />
      {/* <ConsultDoctorSection productData={productData} /> */}
      <OvulationToolContent />
    </>
  );
}
